import { BehaviorSubject } from 'rxjs';
import { FlyingClubFinderFilter } from '../models/flying-club-finder-filter.model';
import * as i0 from "@angular/core";
/**
 * Shares the Flying Club Finder filter state between the landing page, the results page, and the
 * filter-list component. Mirrors {@link AviationEventFiltersService} (a root-provided BehaviorSubject).
 */
var FlyingClubFinderFiltersService = /** @class */ (function () {
    function FlyingClubFinderFiltersService() {
        this.flyingClubFinderFilterSubject$ = new BehaviorSubject(new FlyingClubFinderFilter());
        this.flyingClubFinderFilter = this.flyingClubFinderFilterSubject$.asObservable();
    }
    FlyingClubFinderFiltersService.prototype.updateFlyingClubFinderFilters = function (flyingClubFinderFilter) {
        this.flyingClubFinderFilterSubject$.next(flyingClubFinderFilter);
    };
    FlyingClubFinderFiltersService.ngInjectableDef = i0.defineInjectable({ factory: function FlyingClubFinderFiltersService_Factory() { return new FlyingClubFinderFiltersService(); }, token: FlyingClubFinderFiltersService, providedIn: "root" });
    return FlyingClubFinderFiltersService;
}());
export { FlyingClubFinderFiltersService };
